<template>
  <div class="tag-cloud">
    <a
      v-for="(categoria, index) in categorias"
      :key="index"
      :href="'#' + slugify(categoria.categoria)"
      :class="['tag', randomSize(), `tag-${(index % 25) + 1}`]"
    >
      {{ categoria.categoria }}
    </a>
  </div>
</template>

<script>
export default {
  name: "ProductTagCloud",
  props: {
    categorias: {
      type: Array,
      required: true,
    },
  },
  methods: {
    slugify(text) {
      return text
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/\//g, "-")
        .replace(/[^\w-]+/g, "");
    },
    randomSize() {
      const sizes = ["tag-small", "tag-medium", "tag-large", "tag-xlarge"];
      return sizes[Math.floor(Math.random() * sizes.length)];
    },
  },
};
</script>

<style scoped>
/* ESTILO CLONADO DE RodasepHome.vue TAGS */

.tag-cloud {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 10px 14px; /* más horizontalidad visual */
  padding: 1.2rem 0.5rem;
  max-width: 100%;
}

/* Base */
.tag {
  display: inline-block;
  text-decoration: none;
  color: #111;
  background-color: #eaeaea;
  padding: 0.4em 0.9em;
  border-radius: 30px;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease, transform 0.2s ease;
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.3px;
}

/* Hover con efecto glow azul */
.tag:hover {
  color: #111;
  background-color: #eaeaea;
  transform: translateY(-1px);
  box-shadow: 0 0 8px rgba(0, 169, 224, 1), 0 2px 10px rgba(0, 169, 224, 1);
}

/* Tamaños aleatorios (opcional) */
.tag-small {
  font-size: 0.75rem;
}
.tag-medium {
  font-size: 0.9rem;
}
.tag-large {
  font-size: 1.05rem;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .tag-cloud {
    justify-content: center;
  }
  .tag {
    font-size: 0.85rem;
    padding: 0.3em 0.8em;
  }
}
/* Tonos de fondo variados para dar disparejidad visual */
.tag-1 {
  background-color: #f0f0f0;
}
.tag-2 {
  background-color: #e0e0e0;
}
.tag-3 {
  background-color: #d0d0d0;
}
.tag-4 {
  background-color: #c0c0c0;
}
.tag-5 {
  background-color: #b0b0b0;
}
.tag-6 {
  background-color: #a0a0a0;
  color: #fff;
}
.tag-7 {
  background-color: #909090;
  color: #fff;
}
</style>
